import React from 'react'
import { NavLink,useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import {
	CContainer,
	CHeader,
	CHeaderDivider,
	CImage,
	CRow,
	CCol,
	CForm,
	CFormSelect,
	CButton,
	CFormInput,
	CInputGroup,
	CInputGroupText,
	CLink,
	CTooltip,
	CDropdown,CDropdownToggle,CDropdownMenu,CDropdownItem,
} from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { Konfirm } from '../../helpers/onConfirm'
import { UFunc } from '../../helpers/functions'

const pjson 	= require('../../../package.json')
const Headersubantrianpasien = (props) => {
	const { showToast } = props 

	//--DOM--/
	const uNavigate 			= useNavigate()
	const uDispatch 			= useDispatch()
	//--END DOM--/

	const uHeaderActionObj  	= useSelector(state => state.gInitHeaderAction)
	const uBahasaObj  			= useSelector(state => state.listBahasa)
	const uActiveroute			= useSelector(state => state.activeRoute)
	const uKeywordObj			= JSON.parse(localStorage.getItem("listkeyword")) || {};
	const uTokenObj				= JSON.parse(localStorage.getItem("token")||"{}");
	const uEfekapp				= useSelector(state => state.effectApp);
	const uDatacabangArr		= JSON.parse(localStorage.getItem("cabanglist")||"[]")
	const uCabangfilterArr		= uTokenObj.userhak==="FREEROLE" ? uDatacabangArr
		: uDatacabangArr.filter(vItems=>(uTokenObj.user_cabangarr || []).includes(vItems.id.toString()))
	
	const vFilterview			= uKeywordObj.filter_antrianpasien || {};
	const [uInpCabangid,setInpCabangid]	= React.useState(vFilterview.cabang_id||uTokenObj.user_cabangid);
	const [uInpTglantri,setInpTglantri]	= React.useState(vFilterview.tgl_antri||UFunc.DbDate());

	const hdlKDowntglantri = (_EV) => {
		if(_EV.which==13) {
			_EV.stopPropagation();
			_EV.preventDefault();
			document.getElementById("btnCari") && 
				document.getElementById("btnCari").click();
		}//-*/
	}
	const hdlKlikCari = () => {
		const vTglantriDT	= UFunc.toDate(uInpTglantri);
		if(UFunc.DateIsMundur(vTglantriDT)) {
			showToast("<b>Tanggal Antrian Sudah Expired</b>.."+
				"<br/>Mohon Diperbaiki !"+
				"")
			return;
		}
		if(parseInt(uInpCabangid) <= 0) {
			showToast("[] UNDEFINED.."); return
		}

		//---SAVE_KEYWORD--/
		uKeywordObj.filter_antrianpasien = {
			cabang_id: uInpCabangid,
			tgl_antri: uInpTglantri,
		}
    	localStorage.setItem("listkeyword",JSON.stringify(uKeywordObj));
		//---END SAVE_KEYWORD--/

		uHeaderActionObj.isHeaderView = true;
		uDispatch({type: "set", gInitHeaderAction: uHeaderActionObj});
		uDispatch({type: "set", effectApp: !uEfekapp});
	}
	const hdlKlikReset = async() => {
		const vProses = () => {
			//---CLEAR_KEYWORD--/
			uKeywordObj.filter_antrianpasien = undefined; 
	    	localStorage.setItem("listkeyword",JSON.stringify(uKeywordObj));
	    	setInpTglantri(UFunc.DbDate());
	    	setInpCabangid(uTokenObj.user_cabangid);
			//---END CLEAR_KEYWORD--/
			
			//setHeaderView(true);

			uHeaderActionObj.isHeaderView = true;
			uDispatch({type: "set", gInitHeaderAction: uHeaderActionObj});
			uDispatch({type: "set", effectApp: !uEfekapp});
		}

		if(uInpTglantri !== UFunc.DbDate()
			|| uInpCabangid !== uTokenObj.user_cabangid
		) {
			if(await Konfirm(uBahasaObj.confirm_reset||"Apakah Yakin Akan Direset ?")) vProses();
		} else vProses();	
	}

	//console.log("Headersubantrianpasien - uActiveroute => "+(uActiveroute));
	return (
		<>
		<div className="d-none d-lg-block">
		<CImage src={pjson.homepage+"api/images/menus_"+(uActiveroute||"").toLowerCase()+".png"} 
			className="me-2"
			height={30}/>
		{uBahasaObj["menus_"+(uActiveroute||"").toLowerCase()]||""}
		</div>

		<CForm>
			<CInputGroup 
				style={{minWidth:295,width:"auto"}} 
				size="sm">
			{uDatacabangArr.length > 1 && (
			<>
			{(uTokenObj.userhak==="FREEROLE" || uTokenObj.userhak==="ADMIN") && (
			<>
				<CFormSelect size="sm"
					className="d-none d-md-inline"
					value={uInpCabangid} 
					onChange={(e) => setInpCabangid(e.target.value)} 
					id="inpcabangid">
					{uCabangfilterArr.map((vItems,vKeys)=>{
						return (<option value={vItems.id} key={vKeys}>{vItems.cabang_nama.toUpperCase()}</option>)
					})}
				</CFormSelect>


				<CDropdown className="d-md-none">
					<CDropdownToggle caret={true} className="px-1 border fw-bolder" color="light">
						{(uDatacabangArr.filter(vItems => 
							parseInt(vItems.id) === parseInt(uInpCabangid)
							)[0].cabang_kode || "").toUpperCase()
						}
					</CDropdownToggle>
					<CDropdownMenu>
						{uCabangfilterArr.map((vItems,vKeys)=>{
							return (
							<CDropdownItem key={vKeys} onClick={()=>setInpCabangid(vItems.id)} className="classcursorpointer">
								{vItems.cabang_kode.toUpperCase()}
								<span className="mx-1">-</span>
								{vItems.cabang_nama.toUpperCase()}
							</CDropdownItem>
							)
						})}
					</CDropdownMenu>
				</CDropdown>

				<span className="ms-1"/>
			</>
			)}
			</>
			)}
			<CFormInput size="sm" type="date"
				className="w-50"
				value={uInpTglantri} 
				onChange={(e) => setInpTglantri(e.target.value)} 
				onKeyDown={(e) => hdlKDowntglantri(e)} 
				id="inptglantri"/>
			<CInputGroupText className="p-0">
			<CButton size="sm" 
				color="transparent" 
				className="py-0"
				onClick={()=>hdlKlikCari()} 
				id="btnCari">
				<CIcon icon="cilMagnifyingGlass" className="text-dark" />
			</CButton>
			</CInputGroupText>
			</CInputGroup>
		</CForm>

		<div className="ms-1 d-none d-md-block">
			<CTooltip className="d-none d-md-block" content={"--"+(uBahasaObj.caption_resetdata||"Reset View Tampilan")}>
				<CLink onClick={()=>hdlKlikReset()} className="classikon classikonreset classcursorpointer" />
			</CTooltip>
		</div>
		</>
	)
}

export default Headersubantrianpasien
